import React, { useEffect } from 'react';
/* import { Button } from '@mui/material'; */
import LoginInputs from './loginInputs/loginInputs';
import auth from '../../auth/auth';
import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

import telekom from '../../images/telekom.svg';
import mbh from '../../images/mbh.svg';
import perfekt from '../../images/perfekt.svg';
import logo from '../../images/bookkeepie-logo.svg';
import headset from '../../images/icon-headset.svg';

import classes from './providerEntry.module.scss';

import { useNavigate } from 'react-router';

const ProviderLogin = () => {
	const navigate = useNavigate();
	useEffect(() => {
		/*     console.log(auth.isAuthenticated()); */
		if (auth.isAuthenticated()) {
			navigate('/provider/dashboard');
		}
	}, [navigate]);

	return (
		<div className={classes.EntryContainer}>
			<div className={classes.EntryHeader}>
				<img src={logo} alt='bookkeepie' className={classes.EntryLogo} />
				<div className={classes.RegButton}>
					<span className={classes.MediumText} style={{ marginRight: '12px' }}>
						{i18n.t('general.doyouhavenotyetanaccount')}
					</span>
					{/* <span className={classes.Blue14}> */}
					<a
						className={classes.noDecoration && classes.Blue14}
						href='/provider/register'>
						{i18n.t('general.iamregistering')}
					</a>
					{/* </span> */}
				</div>
			</div>
			<div className={classes.EntryFields}>
				<div className={classes.EntryFieldsBox}>
					<p className={classes.Blue10}>{i18n.t('general.forproviders')}</p>
					<p className={classes.EntryTitle}>{i18n.t('general.iamloggingin')}</p>
					<p className={classes.MediumText}>
						{i18n.t('general.providedetailsandlogin')}
					</p>
					<div className={classes.providerLoginPaper}>
						<LoginInputs />
					</div>
				</div>
				<div className={classes.EntryIssueContact}>
					<img src={headset} alt='headset' />
					<span
						className={classes.SmallText}
						style={{ textDecorationLine: 'none' }}>
						{i18n.t('general.isthereaproblem')}
					</span>
					<span className={classes.Blue12}>
						<a
							href='https://ro.bookkeepie.com/contact-bookkeepie'
							target='_blank'
							rel='noreferrer'>
							{i18n.t('general.contactus')}
						</a>
					</span>
				</div>
				<div className={classes.EntryPartners}>
					<img src={telekom} alt='telekom partner' />
					<img src={mbh} alt='mbh partner' />
					<img src={perfekt} alt='perfekt partner' />
				</div>
			</div>
			<div className={classes.LoginBlueBox}></div>
		</div>
	);
};

export default withTranslation()(ProviderLogin);
